import { Directive, ElementRef, computed, inject, input } from '@angular/core';
import { LIST_LINK_SIZES, type ListLinkSize } from '@groove/core';

// The size vocabulary is owned by @groove/core (framework-neutral, so the
// coverage engine can read it without pulling in @angular/core). Re-exported
// here so consumers can keep importing it from the directive.
export { LIST_LINK_SIZES, type ListLinkSize };

@Directive({
  selector: '[grooveListLink]',
  standalone: true,
  host: {
    class: 'groove-list-link groove-ring groove-interactive',
    '[attr.data-size]': 'sizeAttr()',
    '[attr.data-indent]': 'indent() ? "true" : null',
    '[attr.data-disclosure]': 'disclosure() ? "true" : null',
    '[attr.data-active]': 'dataActiveAttr()',
    '[attr.aria-current]': 'ariaCurrentAttr()',
  },
})
export class GrooveListLinkDirective {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly size = input<ListLinkSize>('md');
  readonly active = input(false);
  readonly indent = input(false);
  readonly disclosure = input(false);

  protected readonly sizeAttr = computed(() =>
    this.size() === 'md' ? null : this.size(),
  );

  // Active on an <a> host → aria-current="page" (semantic nav).
  // Active on anything else → data-active="true".
  protected readonly ariaCurrentAttr = computed(() => {
    if (!this.active()) return null;
    return this.el.nativeElement instanceof HTMLAnchorElement ? 'page' : null;
  });

  protected readonly dataActiveAttr = computed(() => {
    if (!this.active()) return null;
    return this.el.nativeElement instanceof HTMLAnchorElement ? null : 'true';
  });
}
